export default __webpack_public_path__ + "static/ico-telefon-211e2f7bad07c1fd287eb5135ef1f474.svg";